var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" public-object "+_vm._s(_vm.id)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }